import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  RequestDeleteEventDocument,
  RequestDeleteEventMutation,
} from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "event-list",
  label: "Delete Selected Events",
  icon: "warning",
  iconClass: "is-warning",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);

    // for (const e of selection) {
    //   if (e.status !== "Created" && e.status !== "Approved") {
    //     modalService
    //       .dialog({
    //         title: "Delete Selected Events",
    //         body: `Your request contains an event that has already occurred, so you cannot delete it`,
    //         buttons: [{ type: "secondary", label: "Cancel" }],
    //       })
    //       .pipe(take(1))
    //       .subscribe((result) => {});

    //     return;
    //   }
    // }

    modalService
      .dialog({
        title: "Delete Selected Events",
        body: `Do you want to request to delete ${selection.length} events?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<RequestDeleteEventMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(RequestDeleteEventDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            if (res && res.length > 0) {
              notificationService.success(
                `Request to delete ${res.length} event${
                  res.length ? "s" : ""
                } successfully`
              );
            }
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
